import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import logger from '^utils/logger';

import App from './App';

// public-ui ships its global stylesheet separately (its JS entry does not import it).
// This provides the global resets, `:root` design tokens and the
// `* { font-family: var(--theme-font-family) }` rule the theme relies on.
import '@cars4ever/public-ui/dist/index.css';
import '^scss-global';

logger.init();

const root = createRoot(document.getElementById('root')!);

root.render((
  <StrictMode>
    <App />
  </StrictMode>
));
